import { render, staticRenderFns } from "./ProjectDataDerive.vue?vue&type=template&id=00332a0a&scoped=true&"
import script from "./ProjectDataDerive.vue?vue&type=script&lang=ts&"
export * from "./ProjectDataDerive.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDataDerive.vue?vue&type=style&index=0&id=00332a0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00332a0a",
  null
  
)

export default component.exports